import React from 'react'
import styled from '@emotion/styled'
import { Button, Input } from 'antd'

const { Search } = Input

const StyledAccountsListTop = styled.div({
  display: 'flex',
	alignItems: 'center',
  padding: '10px 20px'
})

const InviteButton = styled(Button)({
  marginLeft: 'auto'
})

const UserListTop = ({ handleInviteModalOpen, onSearch }) => {
  return (
    <StyledAccountsListTop>
      <Search
        placeholder="search user by name or email"
        onChange={event => onSearch(event.target.value)}
        style={{ width: 350 }}
      />
      <InviteButton type="primary" icon="usergroup-add" onClick={handleInviteModalOpen}>
        INVITE USERS
      </InviteButton>
    </StyledAccountsListTop>
  )
}

export default UserListTop
